import React, { useEffect, useState } from "react";
import ImageUploader from "./ImageUploader"
import { toast } from "react-toastify";
import { decryptToken } from "./utils/getToken";

const UserRegisterEditModal = ({ isOpen, setIsOpen, fetchData, dataEdit, categories }) => {
    const [text, setText] = useState("");
    const [data, setData] = useState({
        id: "",
        full_name: "",
        email: "",
        profilePic: "",
        website_link: "",
        category: ""
    });

    const urlmain = process.env.REACT_APP_LINK

    const [loading, setLoading] = useState(false);
    const token = decryptToken("accessToken") || ""
    const maxChars = 150;

    const handleChange = (e) => {
        if (e.target.value.length <= maxChars) {
            setText(e.target.value);
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            const response = await fetch(`${urlmain}/register/updatenew/${data.id}`, {
                method: "PUT",
                credentials: "include",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`,
                },
                body: JSON.stringify(data)
            });
            const res = await response.json();
            if (response.ok) {
                toast.success(res.message)
                setLoading(false)
                setIsOpen(false)
                fetchData();
                setData({
                    id: "",
                    full_name: "",
                    email: "",
                    profilePic: "",
                    website_link: "",
                    category: ""
                })
            }
        } catch (error) {
            toast.error(error)
            setLoading(false)
        }

    }

    useEffect(() => {
        if (dataEdit && dataEdit.id) {
            setData({
                id: dataEdit.id,
                full_name: dataEdit.full_name,
                email: dataEdit.email,
                category: dataEdit.category
            });
        }
    }, [dataEdit]);



    if (!isOpen) return null;

    return (
        <>
            <div className="custom-modal-overlay" onClick={() => setIsOpen(false)}>
                <div
                    className="custom-modal-content"
                    onClick={(e) => e.stopPropagation()}
                >
                    <h2 className="oms-modal-title">Edit Admin</h2>
                    <form className="oms-modal-form" onSubmit={handleSubmit}>
                        {/* Title Input */}
                        <div className="oms-form-group">
                            <label htmlFor="title" className="oms-form-label">
                                Full Name
                            </label>
                            <input type="text" name="full_name" id="full_name" value={data.full_name}
                                onChange={handleInputChange}
                                placeholder="Enter Full Name" />
                        </div>
                        <div className="oms-form-group">
                            <label htmlFor="category">Category</label>
                            <select
                                id="category"
                                name="category"
                                value={data.category}
                                onChange={handleInputChange}
                            >
                                <option value="">Select Category</option>
                                {categories.map((cat) => (
                                    <option key={cat.id} value={cat.category_name}>
                                        {cat.category_name}
                                    </option>
                                ))}
                            </select>

                        </div>
                        <div className="oms-form-group">
                            <label htmlFor="title" className="oms-form-label">
                                Email
                            </label>
                            <input type="email" name="email" id="email"
                                onChange={handleInputChange}
                                value={data.email}
                                placeholder="Enter Email" />
                        </div>
                        <div className="oms-form-group">
                            <label htmlFor="profilePic" className="oms-form-label">
                                Profile
                            </label>
                            <input type="file" name="profilePic" id="profilePic"
                                onChange={handleInputChange}
                                value={data.profilePic}
                                placeholder="Enter profilePic" />
                        </div>
                        <div className="oms-form-group">
                            <label htmlFor="website_link" className="oms-form-label">
                                Website Url
                            </label>
                            <input type="text" name="website_link" id="website_link"
                                onChange={handleInputChange}
                                value={data.website_link}
                                placeholder="Enter website_link" />
                        </div>
                        {/* <div className="oms-form-group">
                            <label htmlFor="title" className="oms-form-label">
                                Password
                            </label>
                            <input type="text" name="password" id="password"
                                onChange={handleInputChange}
                                placeholder="Enter Password" />
                        </div> */}


                        {/* Featured Image Upload */}

                        <div className="oms-form-actions">
                            <button type="button" onClick={() => setIsOpen(false)}>
                                Cancel
                            </button>
                            {
                                loading ? <button type="button" disabled={loading}>Loading...</button> : <button type="submit">Submit</button>
                            }
                        </div>
                    </form>
                </div>
            </div>


        </>
    )
}

export default UserRegisterEditModal;